/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from "reactstrap"
import Header from "./header"
import "./layout.css"
import "bootstrap/dist/css/bootstrap.min.css"

const Layout = ({ children, showHome }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} showHome={showHome} />
      <div
        style={{
          margin: `0 auto`,
        }}
      >
        <main>{children}</main>
        <footer>
          <Container
            fluid
            style={{ backgroundColor: "#222", color: "#d8ccc8" }}
            className="py-5"
          >
            <Row>
              <Col style={{ textAlign: "center" }}>
                <h5>
                  <b style={{ color: "white" }} className="raleway-900">
                    The Calibration Station
                  </b>
                </h5>
              </Col>
            </Row>
            <Row>
              <Col
                sm={{ size: 6, offset: 3 }}
                xl={{ size: 4, offset: 4 }}
                className="d-flex mt-3"
                style={{ textAlign: "center" }}
              >
                <p className="flex-fill">422 Coffee Rd Modesto, CA 95355</p>
                <p className="flex-fill pl-3 pl-0-md">
                  1635 T Street Merced, CA 95340
                </p>
              </Col>
            </Row>
            <Row>
              <Col className="text-center">
                <div className="pb-3">
                  <a href="tel:209-497-6710" style={{ color: "#d8ccc8" }}>
                    (209) 497-6710
                  </a>
                </div>
                © {new Date().getFullYear()} The Calibration Station - All
                Rights Reserved
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  showHome: PropTypes.string,
}

export default Layout
